/* tslint:disable */
/* eslint-disable */
/**
 * HAU.ITDE.SpareParts.Purchase.NonShop.Portal.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { LiPimAttribute } from '../model';
// @ts-ignore
import type { ProblemDetails } from '../model';
/**
 * PimApi - axios parameter creator
 * @export
 */
export const PimApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns attribute for a specific sku and attributeId.
         * @param {string} sku 
         * @param {number} attributeId 
         * @param {string} locale 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PimSkuAttributeIdGet: async (sku: string, attributeId: number, locale: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sku' is not null or undefined
            assertParamExists('v1PimSkuAttributeIdGet', 'sku', sku)
            // verify required parameter 'attributeId' is not null or undefined
            assertParamExists('v1PimSkuAttributeIdGet', 'attributeId', attributeId)
            // verify required parameter 'locale' is not null or undefined
            assertParamExists('v1PimSkuAttributeIdGet', 'locale', locale)
            const localVarPath = `/v1/pim/{sku}/{attributeId}`
                .replace(`{${"sku"}}`, encodeURIComponent(String(sku)))
                .replace(`{${"attributeId"}}`, encodeURIComponent(String(attributeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PimApi - functional programming interface
 * @export
 */
export const PimApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PimApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Returns attribute for a specific sku and attributeId.
         * @param {string} sku 
         * @param {number} attributeId 
         * @param {string} locale 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PimSkuAttributeIdGet(sku: string, attributeId: number, locale: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LiPimAttribute>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PimSkuAttributeIdGet(sku, attributeId, locale, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PimApi.v1PimSkuAttributeIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PimApi - factory interface
 * @export
 */
export const PimApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PimApiFp(configuration)
    return {
        /**
         * 
         * @summary Returns attribute for a specific sku and attributeId.
         * @param {string} sku 
         * @param {number} attributeId 
         * @param {string} locale 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PimSkuAttributeIdGet(sku: string, attributeId: number, locale: string, options?: RawAxiosRequestConfig): AxiosPromise<LiPimAttribute> {
            return localVarFp.v1PimSkuAttributeIdGet(sku, attributeId, locale, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PimApi - interface
 * @export
 * @interface PimApi
 */
export interface PimApiInterface {
    /**
     * 
     * @summary Returns attribute for a specific sku and attributeId.
     * @param {string} sku 
     * @param {number} attributeId 
     * @param {string} locale 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PimApiInterface
     */
    v1PimSkuAttributeIdGet(sku: string, attributeId: number, locale: string, options?: RawAxiosRequestConfig): AxiosPromise<LiPimAttribute>;

}

/**
 * PimApi - object-oriented interface
 * @export
 * @class PimApi
 * @extends {BaseAPI}
 */
export class PimApi extends BaseAPI implements PimApiInterface {
    /**
     * 
     * @summary Returns attribute for a specific sku and attributeId.
     * @param {string} sku 
     * @param {number} attributeId 
     * @param {string} locale 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PimApi
     */
    public v1PimSkuAttributeIdGet(sku: string, attributeId: number, locale: string, options?: RawAxiosRequestConfig) {
        return PimApiFp(this.configuration).v1PimSkuAttributeIdGet(sku, attributeId, locale, options).then((request) => request(this.axios, this.basePath));
    }
}

